import React from 'react';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const iconSizes = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 32,
  xl: 44
};
function getSize(size) {
  if (typeof size === "number") {
    return size;
  }
  if (typeof size === "string" && size.includes("em")) {
    return size;
  }
  switch (size) {
    case "xs":
      return iconSizes["xs"];
    case "sm":
      return iconSizes["sm"];
    case "base":
    case "md":
      return iconSizes["md"];
    case "lg":
      return iconSizes["lg"];
    case "xl":
      return iconSizes["xl"];
    default:
      return iconSizes["md"];
  }
}
const withIcon = (IconComponent) => {
  const Wrapper = (_a) => {
    var _b = _a, { size = "base" } = _b, props = __objRest(_b, ["size"]);
    return /* @__PURE__ */ React.createElement(Box, __spreadValues({
      as: IconComponent,
      size: getSize(size)
    }, props));
  };
  return maestroComponent("Icon", Wrapper);
};

export { iconSizes, withIcon };
//# sourceMappingURL=withIcon.es.js.map
